module.exports = __webpack_public_path__ + "static/media/breakfast2.1f7eaafa.png";